import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  Alert,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import "react-phone-input-2/lib/style.css";

import { parseJwt, validateEmail } from "../utils/utils";

const { Select2, Date, DateTime, Text } = Inputs;

function LinkConfirmacionByEmail({ history, match }) {
  const dispatch = useDispatch();
  const modelLink = useSelector((state) => state.getLinkConfirmacion);
  const [username, setUsername] = useState(null);
  const [link, setLink] = useState(null);
  const [codigo, setCodigo] = useState(null);

  useEffect(() => {
    const data = modelLink?.data?.data;
    const errorMessage = modelLink?.error?.response?.data?.mensaje || modelLink?.error?.response?.data?.message;
    const error = modelLink?.error;

    if (error) {
      alert(errorMessage || "Ocurrió un error al realizar la operación");
      dispatch(controller.duckLinkConfirmacion.actions.clear());
    }
    if (data) {
 
        setLink(data.data.link)
        dispatch(controller.duckLinkConfirmacion.actions.clear());

    }
  }, [modelLink]);

  function submit() {
    if (!username) {
      return alert("Por favor complete todos los campos");
    }
    let data = {
      email: username
    };
    dispatch(controller.getLinkConfirmacionByEmailThunk(data));
  }
  return (
    <Content
      title="Link confirmacion"
      browserTitle="Link confirmacion"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Link confirmacion">
            {link && (
              <Col md="12">
                <Alert type="success" title="Exito">
                  <p>{link}</p>
                </Alert>
              </Col>
            )}

            <Text
              labelPosition="above"
              size="sm"
              label="Usuario"
              onChange={(evt) => setUsername(evt.target.value)}
            />
            <Button
              type="primary"
              text="Enviar"
              pullRight={true}
              onClick={() => submit()}
            />
            <Button
              type="default"
              text="Cancelar"
              onClick={() => {
                history.goBack();
              }}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default LinkConfirmacionByEmail;
